// The four-point sparkle from the studio logo. Used as the recurring section
// mark so the page and the logo speak the same language.
function Sparkle({ size = 14, color = 'currentColor', ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d="M12 0c.7 6.2 5.1 11.1 12 12-6.9.9-11.3 5.8-12 12-.7-6.2-5.1-11.1-12-12C6.9 11.1 11.3 6.2 12 0z" />
    </svg>
  );
}

export default Sparkle;
